import type { SampleRuleAction } from "@unbox/api";
import { Select } from "@/components/base/select/select";

const ACTION_OPTIONS: { id: SampleRuleAction; label: string }[] = [
  { id: "approve", label: "Auto-approve" },
  { id: "ignore", label: "Auto-ignore" },
];

interface SampleRuleActionSelectProps {
  value: SampleRuleAction;
  onChange: (action: SampleRuleAction) => void;
  isDisabled?: boolean;
}

export function SampleRuleActionSelect({ value, onChange, isDisabled }: SampleRuleActionSelectProps) {
  return (
    <div className="flex flex-row items-center gap-2">
      <span className="text-sm text-secondary">Action:</span>
      <div className="w-60">
        <Select
          size="sm"
          isDisabled={isDisabled}
          items={ACTION_OPTIONS}
          selectedKey={value}
          onSelectionChange={(key) => {
            if (key === "approve" || key === "ignore") onChange(key);
          }}
        >
          {(item) => <Select.Item id={item.id}>{item.label}</Select.Item>}
        </Select>
      </div>
    </div>
  );
}
